import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, createSession } from "../lib/api";
import { useAuth } from "../lib/auth";
import GitHubStarsLink from "../components/GitHubStarsLink";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    (async () => {
      try {
        // Google OAuth: ?code=...
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        if (code) {
          await api.get(
            `/auth/google/callback?code=${encodeURIComponent(code)}`,
          );
          await refresh();
          window.history.replaceState(null, "", "/dashboard");
          navigate("/dashboard", { replace: true });
          return;
        }

        // Emergent legacy: #session_id=...
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        const session_id = m ? decodeURIComponent(m[1]) : null;
        if (session_id) {
          await createSession(session_id);
          await refresh();
          window.history.replaceState(null, "", "/dashboard");
          navigate("/dashboard", { replace: true });
          return;
        }

        navigate("/", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="fixed top-4 right-6 z-10">
        <GitHubStarsLink
          className="hidden lg:flex items-center gap-2 text-[15px] font-medium tracking-tight text-zinc-600 hover:text-zinc-950 transition-colors"
          testId="github-link-auth-callback"
        />
      </div>
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="overline mb-4">authenticating</div>
        <div className="font-display text-3xl">One moment.</div>
      </div>
    </div>
  );
}
